
<div>
    <router-view />
    <NavigationContextMenu/>
</div>
